export enum PickupType {
  DROPOFF = 'SELF_PICKUP',
  NORMAL = 'NORMAL',
  FIRST_MILE = 'FIRST_MILE',
}
